<template>
  <v-alert
      v-model="showAlert"
      border="top"
      color="orange"
      dense
      close-text="Close Alert"
      icon="$mdiAccount"
      prominent
      type="success"
      dismissible
  >
    {{title}}
    i bims
    {{text}}
  </v-alert>
</template>

<script lang="ts">

import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class AlertDialogComponent extends Vue {

  @Prop({ default: false })
  public showAlert!: boolean;

  @Prop({ default: '' })
  public title!: string;

  @Prop({ default: '' })
  public text!: string;

  public closed() {
    this.$emit('closed');
  }
}
</script>

<style scoped>

</style>
